import type { SearchKey } from '@schibsted-nmp/search-frontend-clients/quest';

export const queryKeys = {
    polePosition: (vars: PolePositionQueryKeyVars) => [vars] as const,
};

type PolePositionQueryKeyVars = {
    searchKey: SearchKey;
    searchParams: SearchParams;
};

export type SearchParams = Record<string, string | string[]>;
